import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { TextField, Button, Stack, Divider, Chip } from "@mui/material";
import axios from "axios";
import { redirect, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import logo from "../assets/images/schedbiz-logo-stack.png";
import styled from "@emotion/styled";
import { VerticalGap } from "src/components/styled/gaps";

const LoginContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const LogoImage = styled.img`
  height: 180px;
`;

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const OrgLogin = (props) => {
  const [state, setState] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const steps = ["Business Details", "Admin User Details"];
  const navigate = useNavigate();

  useEffect(() => {
    const jwtToken = Cookies.get("jwt_token");
    if (jwtToken) {
      navigate("/");
    }
  }, []);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log(data);
    axios
      .post("http://localhost:3000/api/v1/orgUsers/login", data)
      .then(function (response) {
        console.log(response);
        if (response && response.data && response.data.token) {
          // alert(response.data.token);
          // localStorage.setItem("jwt_token", response.data.token);
          Cookies.set("jwt_token", response.data.token);
          navigate("/dashboard");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <LoginContainer>
      <LogoImage src={logo} alt="Schedbiz Logo" />
      <VerticalGap height={"60px"} />
      <FormContainer onSubmit={handleSubmit(onSubmit)} noValidate>
        <Stack spacing={2} width={375}>
          <TextField
            label="Username"
            type="text"
            {...register("email", { required: "Email is required" })}
            error={!!errors.email}
            helperText={errors.email?.message}
          />
          <TextField
            label="Password"
            type="password"
            {...register("password", { required: "Password is required" })}
            error={!!errors.password}
            helperText={errors.password?.message}
          />
        </Stack>

        <VerticalGap height={"40px"} />
        <Button fullWidth type="submit" variant="contained" color="primary">
          Login
        </Button>
        <VerticalGap height={"10px"} />
        <Divider flexItem>
          <Chip label="or" size="small" />
        </Divider>
        <VerticalGap height={"10px"} />
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          onClick={() => {
            navigate("/register");
          }}
        >
          Register
        </Button>
      </FormContainer>
    </LoginContainer>
  );
};

export { OrgLogin };
